/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ErrorName from '../../error/error-name';

/**
 * @import SensorManager from '../../sensor/sensor-manager'
 */

/**
 * Správce fyzických senzorů pro standardní webové technologie.
 * @implements {SensorManager}
 */
export default class WebSensorManager {
  /** @type {SensorManager['getTemperature']} */
  getTemperature() {
    return new Promise(() => {
      const error = new Error('Unable to get the temperature.');
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }
}
